import { createTheme } from '@mui/material/styles';
import '@fontsource-variable/inter';

/**
 * Clean, professional theme with WCAG AA contrast (§81, §82). Colours are neutral defaults until
 * branding is provided (plan/README.md §5 #5).
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1b4d7a', light: '#4a76a3', dark: '#0f3456', contrastText: '#ffffff' },
    secondary: { main: '#2f6f5e', contrastText: '#ffffff' },
    error: { main: '#b3261e' },
    warning: { main: '#8a5300' },
    success: { main: '#1e6b3a' },
    info: { main: '#245f9e' },
    background: { default: '#f5f7fa', paper: '#ffffff' },
    text: { primary: '#1a1f26', secondary: '#4a5361' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter Variable", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontSize: '1.875rem', fontWeight: 700, lineHeight: 1.25 },
    h2: { fontSize: '1.5rem', fontWeight: 650, lineHeight: 1.3 },
    h3: { fontSize: '1.25rem', fontWeight: 650 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { minHeight: 44 } },
    },
    MuiTextField: { defaultProps: { fullWidth: true } },
    MuiCssBaseline: {
      styleOverrides: {
        // Visible focus for keyboard users (§82)
        ':focus-visible': { outline: '3px solid #4a76a3', outlineOffset: '2px' },
      },
    },
  },
});
